// Styles
import StyledAlert from "../styles/StyledAlert";

const Alert = (): JSX.Element => {
  return <StyledAlert>Cannot divide by zero</StyledAlert>;
};

export default Alert;
